import React from 'react';
import SpinnerRing, { type SpinnerRingSize } from './SpinnerRing';

type InlineSpinnerProps = {
  /** Extra classes on the spinner element. */
  className?: string;
  size?: SpinnerRingSize;
  /** Use `current` inside colored buttons; `accent` for standalone inline spinners. */
  variant?: 'current' | 'accent';
  'aria-hidden'?: boolean;
};

/** Small inline spinner (buttons, badges, dialog actions). */
export default function InlineSpinner(props: InlineSpinnerProps): React.ReactElement {
  const { className = '', size = 'sm', variant = 'current', 'aria-hidden': ariaHidden } = props;
  return <SpinnerRing size={size} variant={variant} className={className} aria-hidden={ariaHidden} />;
}
